import SvgIcon from "@mui/material/SvgIcon";

import * as icons from "assets/icons";

function MzIcon({ name, ...props }) {
  const Icon = icons[name];

  return Icon ? <SvgIcon sx={{ fill: "none" }} component={Icon} inheritViewBox {...props} /> : "";
}

export default MzIcon;
